import { useState } from "react";
import { MessageCircle, Phone, X } from "lucide-react";
import { waLink, telLink } from "../lib/api";
import { useContent } from "../context/ContentContext";

export const WhatsAppButton = () => {
  const { contact } = useContent();
  const [open, setOpen] = useState(false);
  const numbers = [contact.whatsapp, contact.whatsapp2].filter(Boolean);

  return (
    <div className="fixed bottom-6 left-4 z-50 flex flex-col items-start gap-3 sm:left-6" data-testid="contact-fab">
      {open && (
        <div
          className="w-72 origin-bottom-left animate-[fadeUp_0.25s_ease] overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-2xl shadow-black/30"
          data-testid="contact-fab-panel"
        >
          <div className="flex items-center justify-between bg-navy px-4 py-3">
            <p className="font-display text-sm font-bold text-white">Contact R.O.K Motors</p>
            <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white" aria-label="Close"><X size={16} /></button>
          </div>
          <div className="space-y-3 p-4">
            {numbers.map((n, i) => (
              <div key={i} className="rounded-xl border border-gray-100 bg-gray-50 p-3" data-testid={`fab-number-${i + 1}`}>
                <p className="text-sm font-bold text-navy">{n}</p>
                <div className="mt-2 flex gap-2">
                  <a
                    href={telLink(n)}
                    data-testid={`fab-call-${i + 1}`}
                    className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-navy px-3 py-2 text-xs font-bold text-white hover:bg-navy-700 active:scale-95"
                  >
                    <Phone size={14} /> Call
                  </a>
                  <a
                    href={waLink(n)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`fab-whatsapp-${i + 1}`}
                    className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-[#25D366] px-3 py-2 text-xs font-bold text-white hover:brightness-95 active:scale-95"
                  >
                    <MessageCircle size={14} /> WhatsApp
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-float-btn"
        aria-label="Contact us"
        className="group relative flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-4 text-white shadow-xl shadow-[#25D366]/40 transition-transform hover:scale-105 active:scale-95"
      >
        {!open && <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-40" />}
        {open ? <X className="relative h-6 w-6" /> : <MessageCircle className="relative h-6 w-6" />}
        <span className="relative hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold transition-all duration-300 group-hover:max-w-xs sm:inline sm:group-hover:pr-1">
          {open ? "Close" : "Chat with us"}
        </span>
      </button>
    </div>
  );
};
